module.exports = __webpack_public_path__ + "static/media/frames-8.945f65b4.jpg";